__turbopack_context__.v({
  "body": "CatalogContentArea-module__1K2X_W__body",
  "componentBadge": "CatalogContentArea-module__1K2X_W__componentBadge",
  "header": "CatalogContentArea-module__1K2X_W__header",
  "lead": "CatalogContentArea-module__1K2X_W__lead",
  "placeholderIntro": "CatalogContentArea-module__1K2X_W__placeholderIntro",
  "title": "CatalogContentArea-module__1K2X_W__title",
  "viewMode": "CatalogContentArea-module__1K2X_W__viewMode",
});
